import { css } from 'lit';

export const style = css`
  .iconic-currency-field {
    margin-bottom: 0.5em;
  }

  fs-currency-field {
    margin-top: 0.5em;
  }

  #income-helper-text {
    margin-bottom: -0.5em;
  }

  .PQv2-income-spacing {
    margin-top: -1em;
  }
`;
